import React from 'react'
import * as actions from '../actions'
import styled from 'styled-components'
import { getPeriod, getYear } from '../selectors'
import { connect } from 'react-redux'
import SelectorOverlay from './SelectorOverlay'
import { Button } from 'antd'
import PeriodLabel from 'analytics/component/PeriodLabel'

const TopBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
`

const UnitGroupSelection = ({
  period,
  // keys,
  // hasData,
  popSelector,
  retrieveByUnit,
  retrieveByGroup,
  yearly,
  year,
  single,
}) => [
  <SelectorOverlay
    key="overlay"
    {...{
      retrieveByUnit,
      retrieveByGroup,
      yearly,
      single,
    }}
  />,
  <TopBar key="top-bar">
    <PeriodLabel {...{ period, yearly, year }} />
    <Button type="primary" onClick={popSelector}>
      Generate Chart
    </Button>
  </TopBar>,
]

const mapStateToProps = state => ({
  period: getPeriod(state),
  year: getYear(state),
})

export default connect(mapStateToProps, actions)(UnitGroupSelection)
